import { EVENT_TYPES } from './event-types'

export default {
  PAYMENT_PAGE_LOADING: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'payment__page_loading',
  },
  PAYMENT_DETAILS_CLOSE_BTN_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_details_close_btn_clicked',
  },
  PAYMENT_DETAILS_INFO_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_details_info_clicked',
  },
  PAYMENT_PAYMENT_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'payment__payment_page_viewed',
  },
  PAYMENT_DETAILS_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_details_clicked',
  },
  PAYMENT_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'payment__page_viewed',
  },
  PAYMENT_ORDER_CART_DETAILS_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__order_cart_details_popup_viewed',
  },
  PAYMENT_LOCKED_ITEM_CLICKED: {
    EVENT_TYPES: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__locked_item_clicked',
  },
  PAYMENT_TYPE_SPLIT_RADIO_CHECKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_type_option_split_your_payment_clicked',
  },
  PAYMENT_TYPE_SPLIT_SI2_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__single_checkout_payment_option_item_si2_clicked',
  },
  PAYMENT_TYPE_SPLIT_SI3_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__single_checkout_payment_option_item_si3_clicked',
  },
  PAYMENT_TYPE_SPLIT_SI4_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__single_checkout_payment_option_item_si4_clicked',
  },
  PAYMENT_TYPE_SPLIT_SI6_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__single_checkout_payment_option_item_si6_clicked',
  },
  PAYMENT_TYPE_PAY_NEXT_MONTH_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment__single_checkout_payment_option_item_pay_next_month_selected',
  },
  PAYMENT_TYPE_PAY_IN_FULL_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment__single_checkout_payment_option_item_pay_in_full_clicked',
  },
  PAYMENT_TYPE_PAY_IN_FULL_LEARN_MORE_CLIECKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment__single_checkout_payment_option_item_pay_in_full_details_popup_viewed',
  },
  PAYMENT_TYPE_PAYMENT_OPTIONS_LIST_ADD_NEW_CARD_CLIECKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_option_list_add_new_card_clicked',
  },
  PAYMENT_OPTIONS_NEW_CARD_NUMBER_INPUT_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__add_new_card_input_number_interacted',
  },

  PAYMENT_OPTIONS_NEW_CARD_EXPIRY_DATE_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__add_new_card_input_expiry_date_interacted',
  },
  PAYMENT_WHAT_IS_CVV_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__what_is_cvv_info_icon_clicked',
  },
  PAYMENT_OPTIONS_NEW_CARD_CVV_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__add_new_card_input_cvv_interacted',
  },
  PAYMENT_OPTIONS_NEW_CARD_POPUP_HIDE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__add_new_card_popup_hide_clicked',
  },
  PAYMENT_OPTIONS_LIST_EXISTING_CARD_SELECTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_option_list_existing_card_clicked',
  },
  PAYMENT_OPTIONS_LIST_APPLE_PAY_SELECTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_option_list_apple_pay_clicked',
  },
  PAYMENT_OPTIONS_CONFIRM_PAYMENT_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__payment_plan_confirmed_btn_clicked',
  },
  PAYMENT_OPTIONS_PAYMENT_PROCESS_INITIATED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__process_initiated',
  },
  PAYMENT_OPTIONS_PAYMENT_PROCESS_SUCCESSFUL: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__process_successful',
  },
  PAYMENT_OPTIONS_PAYMENT_PROCESS_FAILED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__process_failed_viewed',
  },
  PAYMENT_OPTIONS_REDIRECTING_TO_PROVIDER: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__process_redirecting_to_payment_provider',
  },
  PAYMENT_OPTIONS_REDIRECTING_TO_MERCHANT: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__process_completed_redirecting_to_merchant_initiated',
  },
  PAYMENT_OPTIONS_IVR_CALL_CONFIRMATION_POPUP_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_confirmation_popup_viewed',
  },
  PAYMENT_OPTIONS_IVR_CALL_CONFIRMATION_POPUP_CLOSED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_confirmation_popup_closed',
  },
  PAYMENT_OPTIONS_IVR_CALL_CONFIRMATION_POPUP_I_UNDERSTAND_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_confirmation_popup_i_understand_clicked',
  },
  PAYMENT_OPTIONS_IVR_INITIATED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_timer_initiated',
  },
  PAYMENT_OPTIONS_IVR_CALL_SUCCESS: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_successful',
  },
  PAYMENT_OPTIONS_IVR_CALL_FAILED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_failed',
  },
  PAYMENT_OPTIONS_IVR_TIMEOUT_POPUP_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_request_time_out_popup_viewed',
  },
  PAYMENT_OPTIONS_IVR_TIMEOUT_CHANGE_PLAN_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_request_time_out_change_plan_clicked',
  },
  PAYMENT_OPTIONS_IVR_TIMEOUT_RETRY_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_request_time_out_retry_clicked',
  },
  PAYMENT_OPTIONS_IVR_TIMEOUT_CANCEL_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_request_time_out_popup_hide_clicked',
  },
  PAYMENT_OPTIONS_IVR_CALL_MAX_ATTEMPTS_ERROR: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_max_attempts_reached_popup_viewed',
  },
  PAYMENT_OPTIONS_IVR_CALL_MAX_ATTEMPTS_CHANGE_PLAN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_max_attempts_reached_change_plan_clicked',
  },
  PAYMENT_OPTIONS_IVR_CALL_MAX_ATTEMPTS_REDIRECT_TO_MERCHANT: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_max_attempts_reached_back_to_merchant_clicked',
  },
  PAYMENT_OPTIONS_IVR_LEARN_MORE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_learn_more_popup_clicked',
  },
  PAYMENT_OPTIONS_IVR_LEARN_MORE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_learn_more_popup_viewed',
  },
  PAYMENT_OPTIONS_IVR_LEARN_MORE_HIDE: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_call_learn_more_popup_hide_clicked',
  },
  GET_REQUEST_TRIGGERED_AFTER_IVR: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__get_request_triggered_after_ivr',
  },
  GET_REQUEST_NOT_TRIGGERED_AFTER_IVR: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__get_request_not_triggered_after_ivr',
  },
  POST_REQUEST_TRIGGERED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__post_request_triggered',
  },
  IVR_RESPONSE_STEP: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__ivr_response_step',
  },
  PAYMENT_SUBSCRIPTION_POPUP_ACTIVATE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_popup_activate_viewed',
  },
  PAYMENT_SUBSCRIPTION_CSF_SMART_INFO_ICON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_csf_smart_info_icon_clicked',
  },
  PAYMENT_SUBSCRIPTION_CSF_SMART_INFO_POPUP_CLOSED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_csf_smart_info_popup_close_clicked',
  },
  PAYMENT_SUBSCRIPTION_CSF_NON_SMART_INFO_ICON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_csf_non_smart_info_icon_clicked',
  },
  PAYMENT_SUBSCRIPTION_CSF_NON_SMART_INFO_POPUP_CLOSED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__subscriptions_csf_non_smart_info_popup_close_clicked',
  },
  PAYMENT_OVERDUES_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'payment_overdues__page_viewed',
  },
  PAYMENT_OVERDUES_SETTLE_PAY_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__settle_pay_button_clicked',
  },
  PAYMENT_OVERDUES_PAYMENT_OPTION_LIST_ADD_NEW_CARD_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__payment_option_list_add_new_card_clicked',
  },
  PAYMENT_OVERDUES_ADD_NEW_CARD_INPUT_NUMBER_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__add_new_card_input_number_interacted',
  },
  PAYMENT_OVERDUES_ADD_NEW_CARD_INPUT_EXPIRY_DATE_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__add_new_card_input_expiry_date_interacted',
  },
  PAYMENT_OVERDUES_ADD_NEW_CARD_INPUT_CVV_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__add_new_card_input_cvv_interacted',
  },
  PAYMENT_OVERDUES_ADD_NEW_CARD_POPUP_HIDE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__add_new_card_popup_hide_clicked',
  },
  PAYMENT_OVERDUES_PAYMENT_OPTION_LIST_EXISTING_CARD_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__payment_option_list_existing_card_clicked',
  },
  PAYMENT_OVERDUES_PAYMENT_OPTION_LIST_APPLE_PAY_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__payment_option_list_apple_pay_clicked',
  },
  PAYMENT_OVERDUES_PROCESS_INITIATED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__process_initiated',
  },
  PAYMENT_OVERDUES_PROCESS_SUCCESSFUL: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__process_successful',
  },
  PAYMENT_OVERDUES_PROCESS_FAILED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_overdues__process_failed',
  },
  PAYMENT_EARLY_SETTLEMENT_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'payment_early_settlement__page_viewed',
  },
  PAYMENT_EARLY_SETTLEMENT_SETTLE_PAY_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__settle_pay_button_clicked',
  },
  PAYMENT_EARLY_SETTLEMENT_PAYMENT_OPTION_LIST_ADD_NEW_CARD_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment_early_settlement__payment_option_list_add_new_card_clicked',
  },
  PAYMENT_EARLY_SETTLEMENT_ADD_NEW_CARD_INPUT_NUMBER_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment_early_settlement__add_new_card_input_number_interacted',
  },
  PAYMENT_EARLY_SETTLEMENT_ADD_NEW_CARD_INPUT_EXPIRY_DATE_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment_early_settlement__add_new_card_input_expiry_date_interacted',
  },
  PAYMENT_EARLY_SETTLEMENT_ADD_NEW_CARD_INPUT_CVV_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__add_new_card_input_cvv_interacted',
  },
  PAYMENT_EARLY_SETTLEMENT_ADD_NEW_CARD_POPUP_HIDE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__add_new_card_popup_hide_clicked',
  },
  PAYMENT_EARLY_SETTLEMENT_PAYMENT_OPTION_LIST_EXISTING_CARD_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment_early_settlement__payment_option_list_existing_card_clicked',
  },
  PAYMENT_EARLY_SETTLEMENT_PAYMENT_OPTION_LIST_APPLE_PAY_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment_early_settlement__payment_option_list_apple_pay_clicked',
  },
  PAYMENT_EARLY_SETTLEMENT_PROCESS_INITIATED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__process_initiated',
  },
  PAYMENT_EARLY_SETTLEMENT_PROCESS_SUCCESSFUL: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__process_successful',
  },
  PAYMENT_EARLY_SETTLEMENT_PROCESS_FAILED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__process_failed',
  },
  PAYMENT_EARLY_SETTLEMENT_CHANGE_PLAN_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__change_plan_button_clicked',
  },
  PAYMENT_EARLY_SETTLEMENT_CHANGE_PLAN_POPUP_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment_early_settlement__change_plan_popup_viewed',
  },
  PAYMENT_EARLY_SETTLEMENT_CHANGE_PLAN_POPUP_CANCEL_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment_early_settlement__change_plan_popup_cancel_button_clicked',
  },
  PAYMENT_EARLY_SETTLEMENT_CHANGE_PLAN_POPUP_YES_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'payment_early_settlement__change_plan_popup_yes_button_clicked',
  },
  PAYMENT_3DS_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__3ds_interacted',
  },
  PAYMENT_3DS_SUCCESSFUL: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__3ds_successful',
  },
  PAYMENT_3DS_FAILED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__3ds_failed',
  },
  PAYMENT_SUCCESS_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__success_page_viewed',
  },
  PAYMENT_DETAILS_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'payment__details_viewed',
  },
}
